import React, { useState, useEffect } from "react";
import logo from "../assets/01pos.webp";
import loader from "../assets/loader.webp";
import useRotatingImages from "../utility/useRotatingImages";
import { Link, useNavigate } from "react-router";
import { notify } from "../components/toastify";
import { axiosInstance } from "../axiosInstance";

function ResetPassword() {
  const currentImage = useRotatingImages(10000);
  const [email, setEmail] = useState("");
  const [count, setCount] = useState(4);
  const [countDown, setCountDown] = useState(false);
  const navigate = useNavigate();

  const postData = async (newData) => {
    try {
      const response = await axiosInstance.post("api/auth/rest-password", {
        email,
      });

      if (response.data.error === false) {
        notify(response?.data?.message || response?.message, "success");

        // Start countdown after success
        setTimeout(() => {
          setCountDown(true);
        }, 1000);
      } else {
        notify(response?.message || response?.data?.message);
      }
    } catch (err) {
      notify(err?.response?.data?.message || err.message);
      // setTimeout(() => {
      //   setCountDown(true);
      // }, 1000);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    postData(email);
  };

  useEffect(() => {
    let timer;
    if (countDown && count > 0) {
      timer = setInterval(() => {
        setCount((prev) => prev - 1);
      }, 1000);
    }

    if (countDown && count === 0) {
      navigate("/login");
    }

    return () => clearInterval(timer);
  }, [countDown, count, navigate]);

  return (
    <div
      className="relative w-full h-screen bg-cover bg-center"
      style={{ backgroundImage: `url(${currentImage})` }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black opacity-20 z-10"></div>
      {!countDown ? (
        <div className="flex justify-center relative items-center px-4 h-screen z-20">
          <div className="flex flex-col gap-6 px-6 py-8 w-full rounded-md mx-4 md:max-w-[550px] bg-white">
            <form className="flex flex-col " onSubmit={handleSubmit}>
              <div className="flex justify-between items-center">
                <div>
                  <img src={logo} alt="logo" className="w-24" />
                  <h2 className="text-3xl font-semibold">
                    Reset Your Password
                  </h2>
                </div>
              </div>

              <div className="flex flex-col gap-3 my-6">
                <div className="flex flex-col ">
                  <label htmlFor="email">Email</label>
                  <input
                    className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none"
                    placeholder="Youremail@mail.com"
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className="text-lg font-semibold p-2 text-white rounded-lg bg-[#2f345d] w-full flex justify-center hover:bg-[#455093] transition-all"
              >
                Reset Password
              </button>
              <div className="flex justify-end">
                <Link to="/login">
                  <button className="text-sm hover:text-gray-800 mt-1">
                    I remember my password
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="flex justify-center relative items-center px-4 h-screen z-20">
          <div className="bg-white shadow-lg rounded-xl px-8 py-12 text-center">
            <div className="text-6xl font-bold text-blue-600 animate-pulse">
              {count}
            </div>
            <h2 className="mt-4 text-2xl font-semibold text-gray-800">
              Redirecting to Login Page...
            </h2>
            <p className="mt-2 text-sm text-gray-500">
              Check your email for your new password
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ResetPassword;
